import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useRaindropsTable } from '@Modal/hooks/raindrop/useRaindropsTable';
import { useCreateRaindrop } from '@Modal/hooks/raindrop/useCreateRaindrop';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

export const RaindropsTitle: React.FC = () => {
  const { raindropTableFilters, handleClearRaindropTableFilters } = useRaindropsTable();
  const { handleOpenCreateRaindropModal } = useCreateRaindrop();
  const { currentUser, userPermissions } = useAuthorization();
  const permissionToManageRaindrops =
    userPermissions?.includes('CAN_MANAGE_RAINDROP_CAMPAIGNS') || currentUser?.isSuper;
  const objectVals = Object.values(raindropTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="RaindropsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Raindrops</Typography>
        </Stack>
        <Stack direction="row-reverse" gap="10px">
          {permissionToManageRaindrops && (
            <AtLocator type="button" name="clearFilters">
              <Button size="large" variant="contained" onClick={handleOpenCreateRaindropModal}>
                Create Raindrop
              </Button>
            </AtLocator>
          )}
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              disabled={disabled}
              onClick={handleClearRaindropTableFilters}
            >
              Clear filters
            </Button>
          </AtLocator>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
